import React from 'react'

const GreyCircleSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 2C13.9778 2 15.9112 2.58649 17.5557 3.6853C19.2002 4.78412 20.4819 6.3459 21.2388 8.17317C21.9957 10.0004 22.1937 12.0111 21.8079 13.9509C21.422 15.8907 20.4696 17.6725 19.0711 19.0711C17.6725 20.4696 15.8907 21.422 13.9509 21.8079C12.0111 22.1937 10.0004 21.9957 8.17317 21.2388C6.34591 20.4819 4.78412 19.2002 3.68531 17.5557C2.5865 15.9112 2.00001 13.9778 2.00001 12C2.00001 9.34784 3.05357 6.8043 4.92894 4.92893C6.8043 3.05357 9.34784 2 12 2ZM12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21509 0.913451 7.4078C0.00519943 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.8071 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0866C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6935 24 14.3734 24 12C24 8.8174 22.7357 5.76515 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0V0Z"
      fill="#B1B1B1"
    />
  </svg>
)

const GreenCheckMarkSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 12C22 6.49 17.51 2 12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12ZM0 12C0 5.37 5.37 0 12 0C18.63 0 24 5.37 24 12C24 18.63 18.63 24 12 24C5.37 24 0 18.63 0 12ZM11.1571 15.8071L18.0642 8.89999L16.65 7.48578L10.45 13.6858L7.35 10.5858L5.93579 12L9.7429 15.8071C9.93043 15.9946 10.1848 16.1 10.45 16.1C10.7152 16.1 10.9696 15.9946 11.1571 15.8071Z"
      fill="#21BA3A"
    />
  </svg>
)

type Props = {
  selected?: boolean
  hideOnDesktop?: boolean
}

const TickBox = ({ selected, hideOnDesktop }: Props) => (
  <div className="mr-[8px] flex items-center">
    <div className={hideOnDesktop ? 'lg:hidden' : ''}>
      {selected ? <GreenCheckMarkSVG /> : <GreyCircleSVG />}
    </div>
  </div>
)

export default TickBox
